import { useGetAllTechnicianFromUsersQuery } from "../Redux/service/Technician/Technician";

export const useTechnicians = () => {
  const {
    data: techniciansData,
    isFetching,
    refetch,
  } = useGetAllTechnicianFromUsersQuery(
    {
      page: 1,
      pageSize: 10000,
    },
    { refetchOnMountOrArgChange: true }
  );

  const technicians =
    techniciansData?.fieldWorkers?.map((user) => ({
      id: `${user.id}`,
      name: user.name,
      avatar: user.avatar
        ? `${process.env.REACT_APP_BACKEND_URL}/${user.avatar}`
        : null,
      email: user.email,
    })) || [];

  const options = technicians.map((user) => ({
    value: user.id,
    label: user.name,
    avatar: user.avatar,
  }));

  return { techniciansData, technicians, options, isFetching, refetch };
};
